export default function Go_Introduction () {
  return (
    <div>
      <h1>Go_Introduction </h1>
      <p>Go Introduction</p>
    </div>
  );
}